<template>
  <div class="side-center-modal side-center-modal-invite-audience">
    <div class="container-publish-template">
      <ShareToCommunity
        from="presentation-detail"
        :title="getShareToCommunityTitle"
        :presentation="presentation"
        :useInShareV2Modal="isTreatmentShareV2"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShareToCommunity from '@/components-v2/presentation-editor/editor-header/ShareToCommunity.vue'

export default {
  name: 'SideCenterPublishTemplate',
  components: { ShareToCommunity },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['isTreatmentShareV2']),
    getShareToCommunityTitle() {
      if (this.isTreatmentShareV2) return this.$i18nPresenter.t('After publishing, anyone can get a copy of this presentation from the')
      return this.$i18nPresenter.t('After publishing, anyone can get a copy of this presentation from the Template Library')
    },
  },
}
</script>

<style scoped lang="scss">
.container-publish-template {
  & ::v-deep {
    .share-to-community__title {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
